module.exports = __webpack_public_path__ + "static/partner-logos@4x-1bcdcc9125ee5c971c0c94644e518c8a.png";